import { render, staticRenderFns } from "./NotasNewOrEdit.vue?vue&type=template&id=35121413&scoped=true&"
import script from "./NotasNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./NotasNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./NotasNewOrEdit.vue?vue&type=style&index=0&id=35121413&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35121413",
  null
  
)

export default component.exports